
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import wx from 'weixin-js-sdk';

export default {
name: 'card',
components: {
cmBlank,cmLoadmore,Qrcode
},
data () {
return {
isActive:1,
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
popUp:false,
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
count:[],
code:'',
title:'',
price:'',
statusArr:[
{
key:1,
title:'未使用'
},
{
key:2,
title:'已使用'
},
],
}
},
created(){
this.getCardCount();
this.config();
},
mounted(){

},
methods:{
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
selectStatus(key){
this.loadStatus = false;
this.isActive = key;
this.lastId = 0;
this.list = [];
this.getList();
console.log(key);
},
getCardCount(){
this.$api.getCardCount({status:this.isActive}).then((res)=>{
if(res){
this.count = res.data;
}
})
},
getList(){
this.$api.communityCard({status:this.isActive}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
qrcode(i){
this.code = this.list[i].code;
this.title = this.list[i].card.title;
this.price = this.list[i].card.price;
this.popUp = true;
},
getOrder(){
let that = this;
if(!this.code){
that.$func.showToast('核销码无效');
return ;
}
that.$func.startLoading();
this.$api.cardSpecial({code:this.code}).then((res)=>{
if(res){
that.$func.endLoading();
that.$func.showToast('操作成功');
setTimeout(()=>{
that.getCardCount();
that.search();
},500);
}
})
},
scanQRCode(){
let that = this;
this.code = '';
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ["qrCode"],
success: function (res) {
setTimeout(()=>{
that.code = res.resultStr;
that.getOrder();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';

this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/card.vue